import Text from '@/components/basic/text';
import theme from '@/style';
import React from 'react';
import {View, Image} from 'react-native';
import ResultPanel from '../components/result-panel/result-panel';
import {useTranslation} from 'react-i18next';
import {MatkaOrder} from '../result.type';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import {downIcon} from '@/common-pages/rebate/rebate.variables';
import dayjs from 'dayjs';
import {goTo, toPriceStr} from '@/utils';
import {StyleSheet} from 'react-native';

const MatkaDraw = ({order}: {order?: MatkaOrder}) => {
  const {t} = useTranslation();

  const matkaType = [
    '',
    `${t('satta.betting.ank')} ${t('satta.betting.open')}`,
    `${t('satta.betting.ank')} ${t('satta.betting.close')}`,
    t('satta.betting.jodi'),
    `${t('satta.betting.sp')} ${t('satta.betting.open')}`,
    `${t('satta.betting.sp')} ${t('satta.betting.close')}`,
    `${t('satta.betting.dp')} ${t('satta.betting.open')}`,
    `${t('satta.betting.dp')} ${t('satta.betting.close')}`,
    `${t('satta.betting.tp')} ${t('satta.betting.open')}`,
    `${t('satta.betting.tp')} ${t('satta.betting.close')}`,
    `${t('satta.betting.half')} ${t('satta.betting.open')}`,
    `${t('satta.betting.half')} ${t('satta.betting.close')}`,
    t('satta.betting.full'),
  ];

  return order?.orderNo ? (
    <ResultPanel
      betInfo={`${order?.lotteryName} ${order?.openTime}`}
      onMore={() => goTo('Bets', {tag: 'Satta Matka'})}
      betTime={dayjs(order?.orderTime).format('DD-MM-YYYY hh:mm A')}
      containerStyle={styles.panel}>
      <View style={[theme.padding.lrl, theme.padding.tops]}>
        <Text textAlign="center" size="small" accent>
          {t('game-page.label.myBets')}
        </Text>
        <View style={[theme.margin.topxxs, styles.listWrap]}>
          <View
            style={[
              theme.padding.s,
              theme.flex.center,
              theme.borderRadius.m,
              styles.headerCard,
            ]}>
            <Text fontFamily="fontInterBold" size="medium">
              {order?.lotteryName}
            </Text>
          </View>
          {order?.userDigits?.slice(0, 3).map((item, _i) => (
            <View
              key={_i}
              style={[
                theme.flex.row,
                theme.flex.centerByCol,
                theme.flex.between,
                theme.borderRadius.m,
                theme.padding.s,
                styles.itemRow,
              ]}>
              <View style={[theme.flex.row, theme.flex.centerByCol]}>
                <Text size="medium" style={styles.itemLabel}>
                  {matkaType[item.gameType]}
                </Text>
                <Text main fontFamily="fontInterBold" size="medium">
                  {item.digits}
                </Text>
              </View>
              <View style={[theme.flex.row, theme.flex.centerByCol]}>
                <Text size="small" second>
                  {t('bets-detail.label.won')}{' '}
                </Text>
                <Text
                  size="medium"
                  fontFamily="fontInterBold"
                  color={item.status === '1' ? '#F15802' : '#31373D'}>
                  {toPriceStr(+item.digitsWonAmount, {fixed: 1})}
                </Text>
              </View>
            </View>
          ))}
        </View>
        {order?.userDigits && order.userDigits?.length > 3 && (
          <NativeTouchableOpacity
            style={[
              theme.flex.row,
              theme.flex.centerByCol,
              theme.flex.between,
              styles.viewAllRow,
            ]}>
            <Text size="small" second>
              {t('bets-detail.label.viewAll')}
            </Text>
            <View style={[theme.margin.leftxxs, styles.moreIconWrap]}>
              <Image source={downIcon} style={[theme.icon.xs]} />
            </View>
          </NativeTouchableOpacity>
        )}
      </View>
    </ResultPanel>
  ) : null;
};

const styles = StyleSheet.create({
  panel: {
    marginTop: 12,
    marginBottom: 4,
    marginHorizontal: 12,
  },
  headerCard: {
    backgroundColor: '#F4F6FB',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  itemRow: {
    backgroundColor: '#F4F6FB',
  },
  listWrap: {
    rowGap: theme.paddingSize.xxs / 2,
  },
  itemLabel: {
    fontWeight: '500',
    marginRight: 8,
  },
  viewAllRow: {
    height: 32,
    paddingVertical: 8,
  },
  moreIconWrap: {
    transform: [
      {
        rotate: '-90deg',
      },
    ],
  },
});

export default MatkaDraw;
